<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="50" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label-width="38" label="媒体">
          <el-select
            v-model="mediaId"
            :popper-append-to-body="false"
            @change="sendEvent"
            clearable
            filterable
            placeholder="全部"
            style="width: 150px"
          >
            <el-option v-for="item in MEDIAS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <Button type="primary" @click="$emit('on-add')">新增参数</Button>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import { initPageData, MEDIAS } from '@/data/global-opts'

const PAGE_REQUIRED_OPTS = initPageData([MEDIAS])
export default {
  name: 'PushFilter',
  data() {
    return {
      mediaId: ''
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS
  },
  methods: {
    sendEvent() {
      this.$emit('on-change', { mediaId: this.mediaId === '' ? undefined : this.mediaId })
    }
  }
}
</script>
